import { render, staticRenderFns } from "./dm-detail-question.vue?vue&type=template&id=6136ceb9&scoped=true"
import script from "./dm-detail-question.vue?vue&type=script&lang=js"
export * from "./dm-detail-question.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-question.vue?vue&type=style&index=0&id=6136ceb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136ceb9",
  null
  
)

export default component.exports